import { useEffect, useState } from "react";
import { fetchExpressJobDetails } from "../service";
import ModalTemplate from "../../../components/modal/modalTemplate";
import DivSpinner from "../../../components/divSpinner";

const ExpressJobDetails = ({ job_id, show, handleClose }) => {
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        const getExpressJobDetails = async () => {
            try {
                setLoading(true);
                const response = await fetchExpressJobDetails(job_id);
                if (response.status === "Success") {
                    setDetails(response.details)
                }
            } catch (err) {
                console.log("🚀 ~ getExpressJobDetails ~ err:", err);
            } finally {
                setLoading(false);
            }
        }

        getExpressJobDetails();
    }, [job_id]);

    const LoadingComponent = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            centered
            title={"Express job details"}
            body={
                <>
                    {loading ? (
                        <LoadingComponent />
                    ) : (
                        <div className="card  mb-2">
                            <div className="card-header p-2 ps-3">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p className="text-sm mb-0 text-capitalize">{details?.job_express_rule_name}</p>
                                        <h4 className="mb-0">{details?.job_express_surcharge_percentage}%</h4>
                                    </div>
                                    <div className="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                                        <i className="material-icons opacity-10">weekend</i>
                                    </div>
                                </div>
                            </div>
                            <hr className="dark horizontal my-0"/>
                            <div className="card-footer p-2 ps-3">
                                <p className="mb-0 text-sm">{details?.job_express_rule_message}</p>
                            </div>
                        </div>
                    )}
                </>
            }
            footer={<></>}
        />
    );
};

export default ExpressJobDetails;